"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appendThumbnails = appendThumbnails;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * append thumbnails
 * @param {boolean} isDev
 * @param {Object|string} img
 * @param {boolean} isDesktop
 * @return {Object} img with thumbnails
 */
function appendThumbnails(_ref) {
  var img = _ref.img;
  var imgObj = typeof img === 'string' ? {
    url: img
  } : img;
  if (!(0, _isPlainObject2["default"])(imgObj)) return {};
  return _objectSpread(_objectSpread({}, imgObj), {}, {
    thumbnail_sm: imgObj.url,
    thumbnail_md: imgObj.url,
    thumbnail_lg: imgObj.url,
    thumbnail_xl: imgObj.url
  });
}